import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { afterItems, beforeItems, miniStats } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-72" data-mp="26ne8fzi6n7c4">
      <div className="mx-auto w-full max-w-5xl" data-id="element-73" data-mp="22kre9ry1habr">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-74" data-mp="22m2ddegjhtwj">
          Cada paciente con hipotiroidismo plantea una decisión diferente.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy-800/80 sm:text-lg" data-id="element-75" data-mp="2ucqe4peawx9o">
          La Ruta Hipotiroidismo™ organiza todo el proceso en un único sistema
          clínico para que pases de la duda constante a la certeza en cuestión
          de minutos.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-76" data-mp="1et3r9l3wejer">
          {/* ANTES */}
          <div className="rounded-3xl border border-red-100 bg-red-50/60 p-5 sm:p-7" data-id="element-77" data-mp="19uiszr87i9sy">
            <h3 className="mb-5 flex items-center gap-2 font-display text-xl font-black text-red-700 sm:text-2xl" data-id="element-78" data-mp="176npq1qgvj9n">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-79" data-mp="1c3ny4jasgy3x">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-80" data-mp="y6sbfo1m785e" />
              </span>
              Antes
            </h3>
            <ul className="space-y-4" data-id="element-81" data-mp="oeuxi9j8222z">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-82" data-mp="ocs197rh7cpt">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-83" data-mp="t6mogl6ai9tn" />
                  <span className="text-[14px] leading-relaxed text-navy-900/80 sm:text-base" data-id="element-84" data-mp="jfrralri9ptf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* CON RUTA */}
          <div className="rounded-3xl border border-green-200 bg-green-50/70 p-5 sm:p-7" data-id="element-85" data-mp="ae1zhetpoov4">
            <h3 className="mb-5 flex items-center gap-2 font-display text-xl font-black text-green-800 sm:text-2xl" data-id="element-86" data-mp="2c4iyg55l2ymh">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-green-600 text-white" data-id="element-87" data-mp="27cr89vqcauwv">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-88" data-mp="23cgz6a793ods" />
              </span>
              Con Ruta Hipotiroidismo™
            </h3>
            <ul className="space-y-4" data-id="element-89" data-mp="2v2vabynvqmlr">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-90" data-mp="2v0slhhygqzim">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-green-600" aria-hidden="true" data-id="element-91" data-mp="2r2ux2hciohga" />
                  <span className="text-[14px] font-medium leading-relaxed text-navy-900 sm:text-base" data-id="element-92" data-mp="2h3m51u17pcwk">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <dl className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-93" data-mp="15nfd9hn8crc8">
          {miniStats.map(stat => <div key={stat.label} className="rounded-2xl bg-navy-900 px-4 py-5 text-center" data-id="element-94" data-mp="vltjek8ex33y">
              <dt className="sr-only" data-id="element-95" data-mp="10h0ex4rj31hs">{stat.label}</dt>
              <dd data-id="element-96" data-mp="15ho73trhtodl">
                <span className="block font-display text-3xl font-black text-white" data-id="element-97" data-mp="15h4yj3nqgcc8">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-medium text-navy-200 sm:text-sm" data-id="element-98" data-mp="1eb04uf0lc8tg">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <TransformCTA headline="Cambia la duda constante por una única ruta clínica que ya sabe qué sigue." data-id="element-99" data-mp="1o97aw2tcd6go" />
      </div>
    </section>;
}